import { memo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Text, useTheme } from '@Sage/hoi-poi-ui';
import { getLiteral, getLiteralWithParameters } from 'utils/getLiteral';
import { WidgetHeaderLayout } from 'containers/components/widgets/Layouts';

const LocationHeader = memo(({ geoLastUpdated }) => {
    const theme = useTheme();

    return (
        <WidgetHeaderLayout
            content={[{ title: getLiteral('label_location') }]}
            rightPostComponent={
                !!geoLastUpdated && (
                    <Text
                        type="caption"
                        color={theme.colors.textLight.secondary}
                        className="entity-location-widget__last-updated"
                    >
                        {getLiteralWithParameters('label_dana_golden_minute_last_update', [
                            moment(geoLastUpdated, 'DD/MM/YYYY HH:mm:ss').format('L'),
                        ])}
                    </Text>
                )
            }
            rightPostComponentWithoutDivider
        />
    );
});

LocationHeader.propTypes = {
    geoLastUpdated: PropTypes.string,
};

export default LocationHeader;
